import React from 'react';
import styled, { css } from 'styled-components';
import { fontSize, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, HtmlContent } from './ui';
import starsIcon from '../images/stars-icon.svg';

const StyledFeaturedList = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}

  ${({ as }) => {
    if (as === 'h4') {
      return css`
        ${fontSize(18)};

        ${minBreakpointQuery.small`
          ${fontSize(19)};
        `}

        ${minBreakpointQuery.large`
          ${fontSize(20)};
        `}
      `;
    }
  }}
`;

const StyledList = styled.ul``;

const StyledListItem = styled.li`
  margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 35px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}

  &:first-child {
    margin-top: 0;
  }
`;

const StyledListHeading = styled.h3`
  margin-bottom: 20px;
  padding-left: 28px;
  line-height: 1.4;
  background: url(${starsIcon}) no-repeat 0 1px;

  ${minBreakpointQuery.small`
    margin-bottom: 24px;
    padding-left: 30px;
    background-position: 0 2px;
  `}

  ${minBreakpointQuery.large`
    padding-left: 32px;
    background-position: 0 3px;
  `}

  ${({ as }) => {
    if (as === 'h5') {
      return css`
        ${fontSize(17)};
        background-size: 15px;

        ${minBreakpointQuery.small`
          ${fontSize(18)};
          background-size: 16px;
        `}

        ${minBreakpointQuery.large`
          ${fontSize(19)};
          background-size: 17px;
        `}
      `;
    } else {
      return css`
        ${fontSize(18)};
        background-size: 16px;

        ${minBreakpointQuery.small`
          ${fontSize(20)};
          background-size: 18px;
        `}

        ${minBreakpointQuery.large`
          ${fontSize(22)};
          background-size: 20px;
        `}
      `;
    }
  }}
`;

const StyledListText = styled(HtmlContent)`
  p {
    ${fontSize(14)};

    ${minBreakpointQuery.small`
      ${fontSize(15)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(16)};
    `}
  }
`;

const FeaturedList = ({ heading, items, isTabs }) => (
  <StyledFeaturedList>
    <Container narrow={true}>
      <StyledHeading as={isTabs && 'h4'}>{heading}</StyledHeading>
      <StyledList>
        {items.map(({ heading, text }, id) => (
          <StyledListItem key={id}>
            <StyledListHeading as={isTabs && 'h5'}>{heading}</StyledListHeading>
            <StyledListText content={text} />
          </StyledListItem>
        ))}
      </StyledList>
    </Container>
  </StyledFeaturedList>
);

export default FeaturedList;
